import {PayoutType} from '@sollapay/enums';

/**
 * i18n key suffix per `PayoutType`, under
 * `activation.packages.trustDetails.form.options.payoutTypes`. Exhaustive so a new enum member
 * is a compile error until it gets copy.
 */
export const PAYOUT_TYPE_LABEL_KEYS: Record<PayoutType, string> = {
  [PayoutType.DEVELOPER_BANK_ACCOUNT]: 'sellerBankAccount',
  [PayoutType.SELLER_BANK_ACCOUNT]: 'sellerBankAccount',
  [PayoutType.FUNDED_BANK]: 'fundedBank',
  [PayoutType.TRUSTEE]: 'trustee',
  [PayoutType.SUPPLIER]: 'supplier',
  [PayoutType.AUTHORITIES]: 'authorities',
  [PayoutType.OPTION_HOLDER]: 'optionHolder',
  [PayoutType.OTHER]: 'other'
};
